// extracted by mini-css-extract-plugin
module.exports = {"root":"Modal_root__LTe4d","modal":"Modal_modal__wiXHz","modal-content":"Modal_modal-content__4T8au","modal-body":"Modal_modal-body__lzv1N","close-panel":"Modal_close-panel__aE38s"};